module.exports = __webpack_public_path__ + "static/10_Output-d5d76dffee966c221c6ca5f8d1d56b35.png";